export default __webpack_public_path__ + "static/media/2011-SP.d53db92f.jpg";